module.exports = __webpack_public_path__ + "img/roboport-base-patch.3b9c7501.png";